import { render, staticRenderFns } from "./CoastToCoastActivities.vue?vue&type=template&id=234b8f0c&scoped=true&"
import script from "./CoastToCoastActivities.vue?vue&type=script&lang=js&"
export * from "./CoastToCoastActivities.vue?vue&type=script&lang=js&"
import style0 from "./CoastToCoastActivities.vue?vue&type=style&index=0&id=234b8f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b8f0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234b8f0c')) {
      api.createRecord('234b8f0c', component.options)
    } else {
      api.reload('234b8f0c', component.options)
    }
    module.hot.accept("./CoastToCoastActivities.vue?vue&type=template&id=234b8f0c&scoped=true&", function () {
      api.rerender('234b8f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/CoastToCoastActivities.vue"
export default component.exports